import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
    const location = useLocation();
    const currentPath = location.pathname;
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Close menu when route changes
    useEffect(() => {
        setIsMenuOpen(false);
    }, [currentPath]);

    const getLinkClass = (path) => {
        const isActive = currentPath === path;
        const baseClass = "text-sm font-medium leading-normal transition-colors";
        const activeClass = "text-primary dark:text-sky-300";
        const inactiveClass = "text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-primary";

        return `${baseClass} ${isActive ? activeClass : inactiveClass}`;
    };

    return (
        <div className="sticky top-0 z-50 w-full bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
            <div className="max-w-[1200px] mx-auto px-4 lg:px-10">
                <header className="flex items-center justify-between whitespace-nowrap py-4">
                    <div className="flex items-center gap-4">
                        <Link to="/" className="hover:opacity-80 transition-opacity">
                            <h2 className="text-[#284A58] dark:text-white text-lg font-bold leading-tight tracking-[-0.015em] font-display">Yavuz Selim Bostancı</h2>
                        </Link>
                    </div>
                    <div className="flex flex-1 justify-end items-center gap-4 md:gap-8">
                        <nav className="hidden md:flex items-center gap-9">
                            <Link className={getLinkClass('/')} to="/">Home</Link>
                            <Link className={getLinkClass('/experience')} to="/experience">Projects &amp; Experience</Link>
                            <Link className={getLinkClass('/education')} to="/education">Education</Link>
                            <Link className={getLinkClass('/contact')} to="/contact">Contact</Link>
                        </nav>
                        <a href="/assets/yavuz_resume_july_26_nf.pdf" download className="hidden md:flex min-w-[84px] cursor-pointer items-center justify-center rounded-lg h-10 px-4 bg-[#284A58] text-white text-sm font-bold tracking-wide hover:bg-[#203a45] transition-colors">
                            <span>Resume</span>
                        </a>

                        {/* Mobile Menu Toggle */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-2 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                {isMenuOpen ? 'close' : 'menu'}
                            </span>
                        </button>
                    </div>
                </header>

                {/* Mobile Menu Dropdown */}
                {isMenuOpen && (
                    <div className="md:hidden absolute top-[73px] left-0 w-full bg-white dark:bg-[#1a2130] border-b border-slate-200 dark:border-slate-800 shadow-xl animate-fade-in-down">
                        <nav className="flex flex-col p-4 gap-2">
                            <Link className={`p-3 rounded-lg ${currentPath === '/' ? 'bg-primary/10 text-primary' : 'text-slate-600 dark:text-slate-300'}`} to="/">Home</Link>
                            <Link className={`p-3 rounded-lg ${currentPath === '/experience' ? 'bg-primary/10 text-primary' : 'text-slate-600 dark:text-slate-300'}`} to="/experience">Projects &amp; Experience</Link>
                            <Link className={`p-3 rounded-lg ${currentPath === '/education' ? 'bg-primary/10 text-primary' : 'text-slate-600 dark:text-slate-300'}`} to="/education">Education</Link>
                            <Link className={`p-3 rounded-lg ${currentPath === '/contact' ? 'bg-primary/10 text-primary' : 'text-slate-600 dark:text-slate-300'}`} to="/contact">Contact</Link>
                            <hr className="my-2 border-slate-100 dark:border-slate-700" />
                            <a href="/assets/yavuz_resume_july_26_nf.pdf" download className="flex items-center gap-2 p-3 text-slate-600 dark:text-slate-300 font-bold">
                                <span className="material-symbols-outlined">download</span>
                                Download Resume
                            </a>
                        </nav>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Header;
